import styled from 'styled-components';
import { HOVER_BUFFER_SIZE, SIDEBAR_HOVER_Z_INDEX } from '../constants/SidebarConstants';
const CollapsableSidebarEdgeHoverBuffer = styled.div.withConfig({
  displayName: "CollapsableSidebarEdgeHoverBuffer",
  componentId: "sc-1fpromr-0"
})(["position:absolute;width:", "px;height:100%;right:", "px;z-index:", ";"], HOVER_BUFFER_SIZE, props => -(props.fullWidth - HOVER_BUFFER_SIZE / 2), SIDEBAR_HOVER_Z_INDEX);
export default CollapsableSidebarEdgeHoverBuffer;